import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import '../../../../operations/queries/get-contact-lens-by-prescription.js';
import { useFetchCLByPrescription } from '../../../../hooks/use-fetch-cl-by-prescription.js';

const DummyAddToCartCTA = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { actions , state , selectors , triggerToastMessage  } = useCLEcommContext();
    const { configurations  } = state;
    const isLoading = selectors.hasQueryLoading(state);
    const fetchLeftCL = useFetchCLByPrescription({
        eyeSide: 'left'
    });
    const fetchRightCL = useFetchCLByPrescription({
        eyeSide: 'right'
    });
    const fetchBothCL = useFetchCLByPrescription({
        eyeSide: 'both'
    });
    const hasLeftRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, 'left');
    const hasRightRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, 'right');
    const hasBothRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, 'both');
    const hasRecoverableError = selectors.hasRecoverableError(state);
    const hasNonRecoverableError = selectors.hasNonRecoverableError(state);
    const hasNonExecutableQueryError = selectors.hasNonExecutableQueryError(state);
    const isOneColConfigurator = selectors.isOneColConfigurator(state);
    const triggerValidations = React.useCallback(()=>{
        // Form validation errors
        if (!hasNonRecoverableError) {
            actions.triggerValidationErrors();
        }
        // Query errors: non-recoverable
        if (hasNonRecoverableError) {
            triggerToastMessage('non-recoverable-rx-error');
        }
        // Query errors: recoverable
        if (hasRecoverableError && !hasNonRecoverableError) {
            triggerToastMessage('recoverable-error');
        }
        if (hasNonExecutableQueryError) {
            triggerToastMessage('generic-non-recoverable-error');
        }
        // Query errors: recoverable
        // if there was a recoverable error when fetching the SKU by prescription, try the query again
        if (isOneColConfigurator) {
            hasBothRecoverableError && fetchBothCL(configurations.both.prescription);
        } else {
            hasLeftRecoverableError && fetchLeftCL(configurations.left.prescription);
            hasRightRecoverableError && fetchRightCL(configurations.right.prescription);
        }
    }, [
        actions,
        isLoading,
        configurations,
        hasNonRecoverableError,
        hasNonExecutableQueryError,
        hasRecoverableError, 
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        className: className,
        "data-t": "btn-enter-prescription",
        caption: getLabel('products.actions.addToCart'),
        onClick: triggerValidations,
        isLoading: isLoading
    });
};

export { DummyAddToCartCTA };
//# sourceMappingURL=DummyAddToCartCTA.js.map
